import React from 'react';
import clsx from 'clsx';
import { Typography, getTypographyDefaultColor } from '@ag1/ui';
import { TabbedCollection } from 'types/studio/studio';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import styles from './TabbedCollectionThumb.module.scss';

type ThumbActionType = {
  selected: boolean;
  onClick: () => void;
  index: any;
};

type TabbedCollectionItemProps = TabbedCollection['slides'][number];

const TabbedCollectionThumb = ({
  index,
  thumbTitle,
  selected,
  isAGZVariant,
  theme,
  onClick
}: TabbedCollectionItemProps &
  ThumbActionType &
  Pick<TabbedCollection, 'isAGZVariant' | 'theme'>) => (
  <button
    onClick={onClick}
    type="button"
    className={clsx(
      styles.item,
      isAGZVariant && styles.agzBg,
      selected && styles.item_selected,
      getThemeCSSClass(theme)
    )}>
    <Typography
      variant="portalCaption"
      size="1"
      noPadding
      color={getTypographyDefaultColor(theme)}
      className={clsx(styles.num, getThemeCSSClass(theme))}>
      {`${(index + 1).toString().padStart(2, 0)}.`}
    </Typography>
    <Typography
      variant="portalText"
      size="2"
      weight="700"
      noPadding
      color={getTypographyDefaultColor(theme)}
      className={clsx(styles.text, getThemeCSSClass(theme))}>
      {thumbTitle}
    </Typography>
  </button>
);

export default TabbedCollectionThumb;
